import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import {  H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { setFormData, resetFormData } from 'Services/Features/Branch/branchSlice';
import CustomLoader from 'Component/Common/CustomLoader';
import MapWithSearch from 'Component/Maps/LeafletGeosearchMap/MapWithSearch';
import OperationHoursForm from './OperationHour';
import CarouselBannerBranch from '../CarouselBannerBranch'; 

const BranchForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.branch.currentBranch)
    const startUpload = useSelector(state => state.branch.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/clinics`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(data, 'data');
        dispatch(submitBranch({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/clinics`);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangePhotos = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'photos': file }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'photos': null }));
        }
    };

    // make handleChanges for banner like handleChangePhotos but for multiple files and set it to banner[]
    const handleChangeBanner = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'banner': [...data.banner, file] }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'banner': data.banner.filter((banner) => banner !== file) }));
        }
    }


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Col sm="12">
                    <FormGroup row className='mb-3'>
                        <Col sm="6">
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input className="form-control" id="validationName" type="text" name="name" placeholder="Masukkan nama cabang..." required=""
                                value={data.name}
                                onChange={handleChanges} />
                        </Col>
                        <Col sm="6">
                            <Label for="validationPhone" style={{ fontWeight: 'bold' }}>Nomor Telepon :</Label>
                            <Input className="form-control" id="validationPhone" type="number" onWheel={(e) => e.target.blur()} name="phone" placeholder="Masukkan nomor telepon cabang..." required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={data.phone}
                                onChange={handleChanges} />
                        </Col>
                    </FormGroup>
                    <FormGroup className='mb-3'>
                        <Label for="validationLocation" style={{ fontWeight: 'bold' }}>Alamat :</Label>
                        <Input className="form-control" id="validationLocation" type="textarea" name="location" placeholder="Masukkan alamat lengkap cabang..." required=""
                            value={data.location}
                            onChange={handleChanges} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="validationLatLng" style={{ fontWeight: 'bold' }}>Titik Koordinat :</Label>
                        <MapWithSearch initialPosition={{ lat: data.latitude || -7.778287962362472, lng: data.longitude || 110.3927722584372 }} onLocationChange={setFormData} />
                    </FormGroup>
                    <OperationHoursForm />
                </Col>
                <Row className="mb-3">
                    {data.photosLink && (
                        <Col sm="6">
                            <H5>Preview Banner Klinik</H5>
                            <Image
                                attrImage={{
                                    className: 'img-fluid w-100',
                                    src: data.photosLink,
                                    alt: `${data.name}`,
                                    style: {
                                        height: 'auto',
                                        // maxHeight: '300px',  // Atur tinggi maksimal
                                        width: '100%',
                                        maxWidth: '600px',    // Pastikan nggak melebar keluar kolom
                                        objectFit: 'contain', // Biar gambar tetap proporsional
                                        borderRadius: '8px'
                                    }
                                }}
                            />
                        </Col>
                    )}
                    <Col sm={data.photosLink ? 6 : 12}>
                        <DropzoneCommon
                            label={'Banner Klinik'}
                            inputContent={data.photosLink ? 'Update banner klinik' : 'Silahkan upload banner klinik'}
                            handleChangeStatus={handleChangePhotos}
                            accept="image/*"
                            multiple={false}
                            maxFiles={1}
                        />
                    </Col>
                </Row>
                {data.bannerLink && data.bannerLink.length > 1 && (
                    <CarouselBannerBranch slides={3} title='Preview Galeri Foto Klinik' rtl={true} lazyLoad={false} autoplay={false} focusOnSelect={false} images={data.bannerLink} setRefetch={setRefetch}/>
                )}
                {data.bannerLink && data.bannerLink.length === 1 && (
                    <Col sm="12" className="mb-3">
                        <H5>Preview Galeri Foto Klinik</H5>
                        <Image attrImage={{ className: 'img-fluid w-25', src: data.bannerLink[0].url, alt: `${data.name}`, style: { height: '100%', objectFit: 'cover', borderRadius: '8px' } }} />
                    </Col>
                )}
                <DropzoneCommon label={'Galeri Foto Klinik'} inputContent={data.bannerLink && data.bannerLink.length > 0 ? 'update foto galeri klinik' : 'Silahkan upload galeri foto klinik'} handleChangeStatus={handleChangeBanner} accept="image/*" multiple={true} />
            </div>
        </PostCommon>
    );
};

export default BranchForm;